module.exports = __webpack_public_path__ + "static/media/icon_trash.e8700ad3.svg";